
<div class="table-responsive margin-top-15 table-view">
    <h5 class="table-title">QHSSE KPI Year {{currentYear}}</h5>
    <button [disabled]="DisableExport" class="btn btn-primary primary-btn button-excel"  style="margin-bottom: 10px;" (click)="exportToExcel()">
      <i class="fa fa-file-excel-o"></i>Export To Excel</button>
    <p-table [value]="kpiDataFinal" dataKey="Id" editMode="row" id="KPITableToExport">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 4rem;">Sr. No.</th>
          <th style="width: 15rem;">Key Performance Indicators (Leading and Lagging)</th>
          <th style="width: 4rem;"></th>
          <th style="width: 7rem;">Overall Weighting Factor (WF) </th>
          <th style="width: 6rem;">Below Target</th>
          <th style="width: 6rem;">Above target</th>
          <th style="width: 5rem;">Previous Target</th>
          <th style="width: 5rem;">Current Target</th>
          <th style="width: 5rem;">Actual Results</th>
          <th style="width: 7rem;"> Actual (WF) with Traffic light</th>
          <th style="width: 4rem;">Jan</th>
          <th style="width: 4rem;">Feb</th>
          <th style="width: 4rem;">Mar</th>
          <th style="width: 4rem;">Apr</th>
          <th style="width: 4rem;">May</th>
          <th style="width: 4rem;">Jun</th>
          <th style="width: 4rem;">Jul</th>
          <th style="width: 4rem;">Aug</th>
          <th style="width: 4rem;">Sep</th>
          <th style="width: 4rem;">Oct</th>
          <th style="width: 4rem;">Nov</th>
          <th style="width: 4rem;">Dec</th>
          <th style="width: 5rem"></th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-kpiRecord
        let-editing="editing"
        let-ri="rowIndex"
      >
        <tr [pEditableRow]="kpiRecord">
          <td>
            <span>{{ kpiRecord.Id }}</span>
          </td>
          <td>
            <span *ngIf="kpiRecord.ComponentName === 'Safety Observation - Office Staff'">Observation / Interventions - Office Staff</span>
            <span *ngIf="kpiRecord.ComponentName === 'Safety Observation - Field Staff'">Observation / Interventions - Field Staff</span>
            <span *ngIf="kpiRecord.ComponentName === 'Safety Observation - Contractor Crew'">Observation / Interventions - Contractor Crew</span>
            <span *ngIf="kpiRecord.ComponentName !== 'Safety Observation - Office Staff' && kpiRecord.ComponentName !== 'Safety Observation - Field Staff' && kpiRecord.ComponentName !== 'Safety Observation - Contractor Crew'">{{ kpiRecord.ComponentName }}</span>
          </td>
          <td>
            <span *ngIf="kpiRecord.ComponentName === 'Safety Observation - Office Staff'">
              <i class="fa fa-info-circle" [pTooltip]="'Observation / Interventions (Number of observation cards made in MFANO) : Office Staff'"></i>
            </span>
            <span *ngIf="kpiRecord.ComponentName === 'Safety Observation - Field Staff'">
              <i class="fa fa-info-circle" [pTooltip]="'Observation / Interventions (Number of observation cards made in MFANO) : Field Staff'"></i>
            </span>
            <span *ngIf="kpiRecord.ComponentName === 'Safety Observation - Contractor Crew'">
              <i class="fa fa-info-circle" [pTooltip]="'Observation / Interventions (Number of observation cards made in MFANO) : Contractor Crew'"></i>
            </span>
            <span *ngIf="kpiRecord.ComponentName !== 'Safety Observation - Office Staff' && kpiRecord.ComponentName !== 'Safety Observation - Field Staff' && kpiRecord.ComponentName !== 'Safety Observation - Contractor Crew'">
              <i class="fa fa-info-circle" [pTooltip]="kpiRecord.ToolTip"></i>
            </span>
          </td>
          <td >
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="text"
                  [(ngModel)]="kpiRecord.WeightingFactor"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ kpiRecord.WeightingFactor }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td >
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="text"
                  [(ngModel)]="kpiRecord.BelowTarget"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ kpiRecord.BelowTarget }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td >
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="text"
                  [(ngModel)]="kpiRecord.AboveTarget"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ kpiRecord.AboveTarget }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td >
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="text"
                  [(ngModel)]="kpiRecord.PreviousTarget"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ kpiRecord.PreviousTarget }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td >
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="text"
                  [(ngModel)]="kpiRecord.CurrentTarget"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ kpiRecord.CurrentTarget }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td >
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="text"
                  [(ngModel)]="kpiRecord.CurrentResult"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ kpiRecord.CurrentResult }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td >
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="text"
                  [(ngModel)]="kpiRecord.CurrentWFTraficLight"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ kpiRecord.CurrentWFTraficLight }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <span *ngIf="!kpiRecord.Jan.includes(',') && !kpiRecord.Jan.includes('/')">
                  <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Jan"
                      required
                      />
                </span>
                <span *ngIf="kpiRecord.Jan.includes(',') || kpiRecord.Jan.includes('/')">
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Jan.split(kpiRecord.Jan.includes(',') ?',':kpiRecord.Jan.includes('/') ?'/':'')[0]"
                      (change)="upperchange($event.target.value,ri,'Jan',kpiRecord.Jan.includes(',') ?',':kpiRecord.Jan.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                     {{kpiRecord.Jan.includes(',') ?',':kpiRecord.Jan.includes('/') ?'/':''}} 
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Jan.split(kpiRecord.Jan.includes(',') ?',':kpiRecord.Jan.includes('/') ?'/':'')[1]"
                      (change)="lowerchange($event.target.value,ri,'Jan',kpiRecord.Jan.includes(',') ?',':kpiRecord.Jan.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                  </span>
              </ng-template>
              <ng-template pTemplate="output">
                <span *ngIf="!kpiRecord.Jan.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,1,1)" data-target="#AT"> {{ kpiRecord.Jan }}</a>
                  
                </span>
                <span *ngIf="kpiRecord.Jan.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,1,1)" data-target="#AT"> {{ kpiRecord.Jan.split(',')[0] }}<span style="display:none;">&nbsp;-&nbsp;</span></a>
                  
                  <br><br>
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,1,2)" data-target="#AT"> {{kpiRecord.Jan.split(',')[1]}}</a>

                  </span>
                
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <span *ngIf="!kpiRecord.Feb.includes(',') && !kpiRecord.Feb.includes('/')">
                  <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Feb"
                      required
                      />
                </span>
                <span *ngIf="kpiRecord.Feb.includes(',') || kpiRecord.Feb.includes('/')">
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Feb.split(kpiRecord.Feb.includes(',') ?',':kpiRecord.Feb.includes('/') ?'/':'')[0]"
                      (change)="upperchange($event.target.value,ri,'Feb',kpiRecord.Feb.includes(',') ?',':kpiRecord.Feb.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                    {{kpiRecord.Feb.includes(',') ?',':kpiRecord.Feb.includes('/') ?'/':''}}
                   
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Feb.split(kpiRecord.Feb.includes(',') ?',':kpiRecord.Feb.includes('/') ?'/':'')[1]"
                      (change)="lowerchange($event.target.value,ri,'Feb',kpiRecord.Feb.includes(',') ?',':kpiRecord.Feb.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                  </span>
              </ng-template>
              <ng-template pTemplate="output">
                <span *ngIf="!kpiRecord.Feb.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,2,1)" data-target="#AT"> {{ kpiRecord.Feb }}</a>
                  
                </span>
                <span *ngIf="kpiRecord.Feb.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,2,1)" data-target="#AT"> {{ kpiRecord.Feb.split(',')[0] }}<span style="display:none;">&nbsp;-&nbsp;</span></a>
                  
                  <br><br>
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,2,2)" data-target="#AT"> {{kpiRecord.Feb.split(',')[1]}}</a>
                  
                </span>
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <span *ngIf="!kpiRecord.Mar.includes(',') && !kpiRecord.Mar.includes('/')">
                  <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Mar"
                      required
                      />
                </span>
                <span *ngIf="kpiRecord.Mar.includes(',') || kpiRecord.Mar.includes('/')">
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Mar.split(kpiRecord.Mar.includes(',') ?',':kpiRecord.Mar.includes('/') ?'/':'')[0]"
                      (change)="upperchange($event.target.value,ri,'Mar',kpiRecord.Mar.includes(',') ?',':kpiRecord.Mar.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                    {{kpiRecord.Mar.includes(',') ?',':kpiRecord.Mar.includes('/') ?'/':''}}
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Mar.split(kpiRecord.Mar.includes(',') ?',':kpiRecord.Mar.includes('/') ?'/':'')[1]"
                      (change)="lowerchange($event.target.value,ri,'Mar',kpiRecord.Mar.includes(',') ?',':kpiRecord.Mar.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                  </span>
              </ng-template>
              <ng-template pTemplate="output">
                <span *ngIf="!kpiRecord.Mar.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,3,1)" data-target="#AT">  {{ kpiRecord.Mar }}</a>

                 
                </span>
                <span *ngIf="kpiRecord.Mar.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,3,1)" data-target="#AT">  {{ kpiRecord.Mar.split(',')[0] }}<span style="display:none;">&nbsp;-&nbsp;</span></a>
                  
                  <br><br>
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,3,2)" data-target="#AT">  {{kpiRecord.Mar.split(',')[1]}}</a>
                  
                </span>
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <span *ngIf="!kpiRecord.Apr.includes(',') && !kpiRecord.Apr.includes('/')">
                  <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Apr"
                      required
                      />
                </span>
                <span *ngIf="kpiRecord.Apr.includes(',') || kpiRecord.Apr.includes('/')">
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Apr.split(kpiRecord.Apr.includes(',') ?',':kpiRecord.Apr.includes('/') ?'/':'')[0]"
                      (change)="upperchange($event.target.value,ri,'Apr',kpiRecord.Apr.includes(',') ?',':kpiRecord.Apr.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                    {{kpiRecord.Apr.includes(',') ?',':kpiRecord.Apr.includes('/') ?'/':''}}
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Apr.split(kpiRecord.Apr.includes(',') ?',':kpiRecord.Apr.includes('/') ?'/':'')[1]"
                      (change)="lowerchange($event.target.value,ri,'Apr',kpiRecord.Apr.includes(',') ?',':kpiRecord.Apr.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                  </span>
              </ng-template>
              <ng-template pTemplate="output">
                <span *ngIf="!kpiRecord.Apr.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,4,1)" data-target="#AT">  {{ kpiRecord.Apr }}</a>

                  
                </span>
                <span *ngIf="kpiRecord.Apr.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,4,1)" data-target="#AT">  {{ kpiRecord.Apr.split(',')[0] }}<span style="display:none;">&nbsp;-&nbsp;</span></a>
                  
                  <br><br>
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,4,2)" data-target="#AT">  {{kpiRecord.Apr.split(',')[1]}}</a>
                  
                </span>
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <span *ngIf="!kpiRecord.May.includes(',') && !kpiRecord.May.includes('/')">
                  <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.May"
                      required
                      />
                </span>
                <span *ngIf="kpiRecord.May.includes(',') || kpiRecord.May.includes('/')">
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.May.split(kpiRecord.May.includes(',') ?',':kpiRecord.May.includes('/') ?'/':'')[0]"
                      (change)="upperchange($event.target.value,ri,'May',kpiRecord.May.includes(',') ?',':kpiRecord.May.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                    {{kpiRecord.May.includes(',') ?',':kpiRecord.May.includes('/') ?'/':''}}
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.May.split(kpiRecord.May.includes(',') ?',':kpiRecord.May.includes('/') ?'/':'')[1]"
                      (change)="lowerchange($event.target.value,ri,'May',kpiRecord.May.includes(',') ?',':kpiRecord.May.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                  </span>
              </ng-template>
              <ng-template pTemplate="output">
                <span *ngIf="!kpiRecord.May.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,5,1)" data-target="#AT">  {{ kpiRecord.May }}</a>
                  
                </span>
                <span *ngIf="kpiRecord.May.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,5,1)" data-target="#AT">  {{ kpiRecord.May.split(',')[0] }}<span style="display:none;">&nbsp;-&nbsp;</span></a>
                  
                  <br><br>
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,5,2)" data-target="#AT">  {{kpiRecord.May.split(',')[1]}}</a>
                  
                </span>
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <span *ngIf="!kpiRecord.Jun.includes(',') && !kpiRecord.Jun.includes('/')">
                  <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Jun"
                      required
                      />
                </span>
                <span *ngIf="kpiRecord.Jun.includes(',') || kpiRecord.Jun.includes('/')">
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Jun.split(kpiRecord.Jun.includes(',') ?',':kpiRecord.Jun.includes('/') ?'/':'')[0]"
                      (change)="upperchange($event.target.value,ri,'Jun',kpiRecord.Jun.includes(',') ?',':kpiRecord.Jun.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                    {{kpiRecord.Jun.includes(',') ?',':kpiRecord.Jun.includes('/') ?'/':''}}
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Jun.split(kpiRecord.Jun.includes(',') ?',':kpiRecord.Jun.includes('/') ?'/':'')[1]"
                      (change)="lowerchange($event.target.value,ri,'Jun',kpiRecord.Jun.includes(',') ?',':kpiRecord.Jun.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                  </span>
              </ng-template>
              <ng-template pTemplate="output">
                <span *ngIf="!kpiRecord.Jun.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,6,1)" data-target="#AT">   {{ kpiRecord.Jun }}</a>
                 
                </span>
                <span *ngIf="kpiRecord.Jun.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,6,1)" data-target="#AT">   {{ kpiRecord.Jun.split(',')[0] }}<span style="display:none;">&nbsp;-&nbsp;</span></a>
                  
                  <br><br>
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,6,2)" data-target="#AT">   {{kpiRecord.Jun.split(',')[1]}}</a>
                  
                </span>
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <span *ngIf="!kpiRecord.Jul.includes(',') && !kpiRecord.Jul.includes('/')">
                  <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Jul"
                      required
                      />
                </span>
                <span *ngIf="kpiRecord.Jul.includes(',') || kpiRecord.Jul.includes('/')">
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Jul.split(kpiRecord.Jul.includes(',') ?',':kpiRecord.Jul.includes('/') ?'/':'')[0]"
                      (change)="upperchange($event.target.value,ri,'Jul',kpiRecord.Jul.includes(',') ?',':kpiRecord.Jul.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                    {{kpiRecord.Jul.includes(',') ?',':kpiRecord.Jul.includes('/') ?'/':''}}
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Jul.split(kpiRecord.Jul.includes(',') ?',':kpiRecord.Jul.includes('/') ?'/':'')[1]"
                      (change)="lowerchange($event.target.value,ri,'Jul',kpiRecord.Jul.includes(',') ?',':kpiRecord.Jul.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                  </span>
              </ng-template>
              <ng-template pTemplate="output">
                <span *ngIf="!kpiRecord.Jul.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,7,1)" data-target="#AT">   {{ kpiRecord.Jul }}</a>
                  
                </span>
                <span *ngIf="kpiRecord.Jul.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,7,1)" data-target="#AT">   {{ kpiRecord.Jul.split(',')[0] }}<span style="display:none;">&nbsp;-&nbsp;</span></a>
                  
                  <br><br>
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,7,2)" data-target="#AT">   {{kpiRecord.Jul.split(',')[1]}}</a>
                  
                </span>
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <span *ngIf="!kpiRecord.Aug.includes(',') && !kpiRecord.Aug.includes('/')">
                  <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Aug"
                      required
                      />
                </span>
                <span *ngIf="kpiRecord.Aug.includes(',') || kpiRecord.Aug.includes('/')">
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Aug.split(kpiRecord.Aug.includes(',') ?',':kpiRecord.Aug.includes('/') ?'/':'')[0]"
                      (change)="upperchange($event.target.value,ri,'Aug',kpiRecord.Aug.includes(',') ?',':kpiRecord.Aug.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                    {{kpiRecord.Aug.includes(',') ?',':kpiRecord.Aug.includes('/') ?'/':''}}
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Aug.split(kpiRecord.Aug.includes(',') ?',':kpiRecord.Aug.includes('/') ?'/':'')[1]"
                      (change)="lowerchange($event.target.value,ri,'Aug',kpiRecord.Aug.includes(',') ?',':kpiRecord.Aug.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                  </span>
              </ng-template>
              <ng-template pTemplate="output">
                <span *ngIf="!kpiRecord.Aug.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,8,1)" data-target="#AT">   {{ kpiRecord.Aug }}</a>
                  
                </span>
                <span *ngIf="kpiRecord.Aug.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,8,1)" data-target="#AT">   {{ kpiRecord.Aug.split(',')[0] }}<span style="display:none;">&nbsp;-&nbsp;</span></a>
                  
                  <br><br>
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,8,2)" data-target="#AT">   {{kpiRecord.Aug.split(',')[1]}}</a>
                  
                </span>
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <span *ngIf="!kpiRecord.Sep.includes(',') && !kpiRecord.Sep.includes('/')">
                  <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Sep"
                      required
                      />
                </span>
                <span *ngIf="kpiRecord.Sep.includes(',') || kpiRecord.Sep.includes('/')">
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Sep.split(kpiRecord.Sep.includes(',') ?',':kpiRecord.Sep.includes('/') ?'/':'')[0]"
                      (change)="upperchange($event.target.value,ri,'Sep',kpiRecord.Sep.includes(',') ?',':kpiRecord.Sep.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                    {{kpiRecord.Sep.includes(',') ?',':kpiRecord.Sep.includes('/') ?'/':''}}
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Sep.split(kpiRecord.Sep.includes(',') ?',':kpiRecord.Sep.includes('/') ?'/':'')[1]"
                      (change)="lowerchange($event.target.value,ri,'Sep',kpiRecord.Sep.includes(',') ?',':kpiRecord.Sep.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                  </span>
              </ng-template>
              <ng-template pTemplate="output">
                <span *ngIf="!kpiRecord.Sep.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,9,1)" data-target="#AT">   {{ kpiRecord.Sep }}</a>
                  
                </span>
                <span *ngIf="kpiRecord.Sep.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,9,1)" data-target="#AT">   {{ kpiRecord.Sep.split(',')[0] }}<span style="display:none;">&nbsp;-&nbsp;</span></a>
                  
                  <br><br>
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,9,2)" data-target="#AT">   {{kpiRecord.Sep.split(',')[1]}}</a>
                  
                </span>
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <span *ngIf="!kpiRecord.Oct.includes(',') && !kpiRecord.Oct.includes('/')">
                  <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Oct"
                      required
                      />
                </span>
                <span *ngIf="kpiRecord.Oct.includes(',') || kpiRecord.Oct.includes('/')">
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Oct.split(kpiRecord.Oct.includes(',') ?',':kpiRecord.Oct.includes('/') ?'/':'')[0]"
                      (change)="upperchange($event.target.value,ri,'Oct',kpiRecord.Oct.includes(',') ?',':kpiRecord.Oct.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                    {{kpiRecord.Oct.includes(',') ?',':kpiRecord.Oct.includes('/') ?'/':''}}
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Oct.split(kpiRecord.Oct.includes(',') ?',':kpiRecord.Oct.includes('/') ?'/':'')[1]"
                      (change)="lowerchange($event.target.value,ri,'Oct',kpiRecord.Oct.includes(',') ?',':kpiRecord.Oct.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                  </span>
              </ng-template>
              <ng-template pTemplate="output">
                <span *ngIf="!kpiRecord.Oct.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,10,1)" data-target="#AT">   {{ kpiRecord.Oct }}</a>
                  
                </span>
                <span *ngIf="kpiRecord.Oct.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,10,1)" data-target="#AT">   {{ kpiRecord.Oct.split(',')[0] }}<span style="display:none;">&nbsp;-&nbsp;</span></a>

                  
                  <br><br>
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,10,2)" data-target="#AT">   {{kpiRecord.Oct.split(',')[1]}}</a>

                  
                </span>
              </ng-template>
            </p-cellEditor>
          </td>

          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <span *ngIf="!kpiRecord.Nov.includes(',') && !kpiRecord.Nov.includes('/')">
                  <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Nov"
                      required
                      />
                </span>
                <span *ngIf="kpiRecord.Nov.includes(',') || kpiRecord.Nov.includes('/')">
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Nov.split(kpiRecord.Nov.includes(',') ?',':kpiRecord.Nov.includes('/') ?'/':'')[0]"
                      (change)="upperchange($event.target.value,ri,'Nov',kpiRecord.Nov.includes(',') ?',':kpiRecord.Nov.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                    {{kpiRecord.Nov.includes(',') ?',':kpiRecord.Nov.includes('/') ?'/':''}}
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Nov.split(kpiRecord.Nov.includes(',') ?',':kpiRecord.Nov.includes('/') ?'/':'')[1]"
                      (change)="lowerchange($event.target.value,ri,'Nov',kpiRecord.Nov.includes(',') ?',':kpiRecord.Nov.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                  </span>
              </ng-template>
              <ng-template pTemplate="output">
                <span *ngIf="!kpiRecord.Nov.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,11,1)" data-target="#AT">   {{ kpiRecord.Nov }}</a>
                  
                </span>
                <span *ngIf="kpiRecord.Nov.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,11,1)" data-target="#AT">   {{ kpiRecord.Nov.split(',')[0] }}<span style="display:none;">&nbsp;-&nbsp;</span></a>
                  
                  <br><br>
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,11,2)" data-target="#AT">   {{kpiRecord.Nov.split(',')[1]}}</a>
                  
                </span>
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <span *ngIf="!kpiRecord.Dec.includes(',') && !kpiRecord.Dec.includes('/')">
                  <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Dec"
                      required
                      />
                </span>
                <span *ngIf="kpiRecord.Dec.includes(',') || kpiRecord.Dec.includes('/')">
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Dec.split(kpiRecord.Dec.includes(',') ?',':kpiRecord.Dec.includes('/') ?'/':'')[0]"
                      (change)="upperchange($event.target.value,ri,'Dec',kpiRecord.Dec.includes(',') ?',':kpiRecord.Dec.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                    {{kpiRecord.Dec.includes(',') ?',':kpiRecord.Dec.includes('/') ?'/':''}}
                    <span>
                      <input
                      pInputText
                      type="text"
                      [(ngModel)]="kpiRecord.Dec.split(kpiRecord.Dec.includes(',') ?',':kpiRecord.Dec.includes('/') ?'/':'')[1]"
                      (change)="lowerchange($event.target.value,ri,'Dec',kpiRecord.Dec.includes(',') ?',':kpiRecord.Dec.includes('/') ?'/':'')"
                      required
                      />
                    </span>
                  </span>
              </ng-template>
              <ng-template pTemplate="output">
                <span *ngIf="!kpiRecord.Dec.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,12,1)" data-target="#AT">   {{ kpiRecord.Dec }}</a>
                  
                </span>
                <span *ngIf="kpiRecord.Dec.includes(',')">
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,12,1)" data-target="#AT">   {{ kpiRecord.Dec.split(',')[0] }}<span style="display:none;">&nbsp;-&nbsp;</span></a>
                  
                  <br><br>
                  <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
                  (click)="GetKPISelectedDetails(0,kpiRecord.ComponentName,12,2)" data-target="#AT">   {{kpiRecord.Dec.split(',')[1]}}</a>
                  
                </span>
              </ng-template>
            </p-cellEditor>
          </td>
          <td style="text-align: center">
            <button
              *ngIf="!editing"
              pButton
              pRipple
              type="button"
              pInitEditableRow
              icon="pi pi-pencil"
              (click)="onRowEditInit(kpiRecord)"
              class="p-button-rounded p-button-text"
            ></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pSaveEditableRow
              icon="pi pi-check"
              (click)="onRowEditSave(kpiRecord)"
              class="p-button-rounded p-button-text p-button-success p-mr-2"
            ></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pCancelEditableRow
              icon="pi pi-times"
              (click)="onRowEditCancel(kpiRecord,ri)"
              class="p-button-rounded p-button-text p-button-danger"
            ></button>
          </td>
      </tr>
    </ng-template>
    </p-table>
</div>

<div class="modal fade PDModal" data-backdrop="static" style="opacity:1 !important;" id="AT" role="dialog">
  <div class="modal-dialog custom-modal">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        
          <button type="button" class="close button-cancel" data-dismiss="modal">&times;</button>
        <!-- <h4 class="modal-title custom_align" id="Heading">Risk Assessment Matrix</h4> -->
      </div>
      <div class="modal-body">       
        <ol id="liPDheight">
          <ng-container *ngFor="let item of KPIData1; let i=index">       
            <li *ngIf="item.Text.includes('ACT')"><a (click)="Redirect2(item.value,item.ID)">{{item.Text }}</a></li>
            <li *ngIf="item.Text.includes('OBS')"><a (click)="Redirect1(item.value,item.ID)">{{item.Text }}</a></li>
            <li *ngIf="item.Text.includes('INC')"><a (click)="Redirect(item.value,item.ID)">{{item.Text }}</a></li>
            <li *ngIf="item.Text.includes('TSK')"><a (click)="Redirect3(item.value,item.ID)">{{item.Text }}</a></li>
         </ng-container>   
        </ol>
        <span *ngIf="KPIData1?.length < 1" style="color:red;">No Records Found..</span>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</div>